'use client'

import { useRef, useState, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip'

interface OverflowTextProps {
  children: ReactNode
  className?: string
  text?: string
}

export function OverflowText({ children, className, text }: OverflowTextProps) {
  const [overflowed, setOverflowed] = useState(false)
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLSpanElement>(null)

  const checkOverflow = () => {
    const element = ref.current
    setOverflowed(
      Boolean(element && (element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight)),
    )
  }

  return (
    <Tooltip open={open && overflowed} onOpenChange={setOpen}>
      <TooltipTrigger
        render={<span ref={ref} className={cn('block min-w-0 max-w-full truncate', className)} tabIndex={0} />}
        onMouseEnter={checkOverflow}
        onMouseDown={(event) => event.preventDefault()}
        onFocus={checkOverflow}
      >
        {children}
      </TooltipTrigger>
      <TooltipContent className="whitespace-pre-wrap select-text">{text ?? children}</TooltipContent>
    </Tooltip>
  )
}
